<template>
	<div class="setting">
		<van-nav-bar title="设置" left-arrow @click-left="onClickLeft" />
		<div class="setting-box">
			<van-uploader :before-read="beforeRead" :after-read="afterRead">
				<div class="setting-item flex-space-between">
					<p>头像</p>
					<div class="setting-item-right align-items-center">
						<div class="setting-item-right-img">
							<van-loading v-if="uploadLoading" class="uploadLoading" size="20px" color="#1989fa" />
							<img :src="userInfo.headImage || require('../../../assets/images/account/userdefault.png')" />
						</div>
						<van-icon name="arrow" />
					</div>
				</div>
			</van-uploader>
			<div class="setting-item flex-space-between" @click="handleEdit('name')">
				<p>姓名</p>
				<div class="setting-item-right align-items-center">
					<p>{{ userInfo.name }}</p>
					<van-icon name="arrow" />
				</div>
			</div>
			<div class="setting-item flex-space-between" @click="handleEdit('nickname')">
				<p>昵称</p>
				<div class="setting-item-right align-items-center">
					<p>{{ userInfo.nickname }}</p>
					<van-icon name="arrow" />
				</div>
			</div>
			<div class="setting-item flex-space-between">
				<p>电话</p>
				<div class="setting-item-right">
					<!-- <p>{{userInfo.phone || ''}}</p> -->
					<p>{{ $store.state.userInfo.phone || '' }}</p>
				</div>
			</div>
		</div>
		<div class="signOut" @click="handleSignOut">
			退出登录
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import md5 from 'js-md5'
export default {
	name: 'setting',
	data() {
		return {
			uploadLoading: false,
			isReal: false,
		}
	},
	computed: {
		...mapState(['userInfo']),
	},
	created() {
		this.isRealNameAuthentication()
	},
	methods: {
		isRealNameAuthentication() {
			this.$api.exam.isRealNameAuthentication({}).then((data) => {
				const token = localStorage.getItem('token')
				this.isReal = data.code === 0 && md5(token + 'true') === data.data
			})
		},
		beforeRead(file) {
			this.uploadLoading = true
			if (file.type.indexOf('image') === -1) {
				this.$notify({ duration: 2000, type: 'danger', message: '请上传正确格式的图片' })
				this.uploadLoading = false
				return false
			}
			return true
		},
		afterRead(file) {
			// 此时可以自行将文件上传至服务器
			let formData = new FormData()
			formData.append('file', file.file)
			this.$api.user
				.upload(formData)
				.then(async (res) => {
					if (res.code == 0) {
						// 保存头像
						try {
							let result = await this.$api.user.updateUser({ headImage: res.data })
							if (result.success) {
								this.uploadLoading = false
								this.userInfo.headImage = res.data
								this.$store.commit('setUserInfo', { headImage: res.data })
							} else {
								this.uploadLoading = false
							}
						} catch (error) {
							this.uploadLoading = false
						}
					}
				})
				.catch((err) => {
					this.uploadLoading = false
				})
		},
		handleSignOut() {
			const params = {
				token: localStorage.getItem('token') || null,
			}
			this.$api.account.logout({ params }).then((res) => {
				if (res.data) {
                    const branchId = localStorage.getItem('branchId')
                    const saasId = localStorage.getItem('saasId')
					localStorage.clear()
                    sessionStorage.clear()
                    localStorage.setItem('branchId', branchId)
                    localStorage.setItem('saasId', saasId)
					this.$store.commit('setUserInfo',{})
					this.$router.replace('/login')
				} else {
					this.$toast('退出失败')
				}
			})
		},
		onClickLeft() {
			this.$router.go(-1)
		},
		handleEdit(type) {
			if (type === 'name' && this.isReal) {
				this.$toast('已经实名认证过不允许修改姓名')
				return
			}
			this.$router.push({
				path: '/edit',
				query: {
					type,
				},
			})
		},
	},
}
</script>
<style lang="stylus" scoped>
.flex-space-between{
    display :flex;
    justify-content:space-between;
    align-items :center;
}
.align-items-center{
    display :flex;
    align-items :center;
}
.setting{
    height:100vh;
    background #F7F7F7
    position:relative;
    .signOut{
        width 100%
        height 100px
        background #fff
        margin-top 30px
        font-size: 30px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        text-align center
        line-height 100px
    }
    .setting-box{
        padding:0 30px;
        background #fff
        box-sizing :border-box;
        .van-uploader,/deep/ .van-uploader__wrapper,/deep/ .van-uploader__input-wrapper {
            width 100%
        }
    }
    .setting-item{
        padding:34px 0;
        border-bottom:1px solid #EAEAEA;
          p{
                font-size:30px;
            }
        &:nth-child(1){
            padding:20px 0;
        }
        &:last-child {
            border-bottom 0
        }
        .setting-item-left{
            color:#333333;
        }
        .setting-item-right{
            .van-icon{
                color:#666;
                font-size :13px;
                margin-left 4px
            }
            .setting-item-right-img{
                width:100px;
                height:100px;
                border-radius:50%;
                position relative
                .uploadLoading {
                    position absolute
                    left 0
                    right 0
                    top 0
                    bottom 0
                    background-color rgba(255,255,255,.6)
                    border-radius 50%
                    text-align center
                    /deep/ .van-loading__spinner {
                        margin-top 15px
                    }
                }
                img{
                    width:100px;
                    height:100px;
                    border-radius:50%;
                }
            }
            p{
                color:#666;
                font-size:26px;
            }
        }
    }
}
</style>
